import React from 'react';

interface BackgroundWrapperProps {
  children: React.ReactNode;
}

const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({ children }) => {
  return (
    <div className="bg-wrapper">
      {/* Stars background - fixed for entire page */}
      <div className="stars-container">
        {[...Array(150)].map((_, i) => (
          <div
            key={i}
            className="star"
            style={{
              width: Math.random() * 3 + 1 + 'px',
              height: Math.random() * 3 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
              animationDelay: Math.random() * 3 + 's',
              opacity: Math.random() * 0.7 + 0.3,
              backgroundColor: 'white',
            }}
          />
        ))}
      </div>
      {children}
    </div>
  );
};

export default BackgroundWrapper;